var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"material-final-step"},[_c('p',{staticClass:"mfs-help"},[_vm._v(" Tu informe se ha generado. Cuéntanos qué te pareció: ")]),_c('FeedbackComponent',{attrs:{"code":_vm.feedbackCode}}),_c('div',{staticClass:"mfs-footer"},[_c('button',{staticClass:"mfs-finish-btn",on:{"click":_vm.onFinish}},[_vm._v(_vm._s(_vm.finishLabel))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }